import React from 'react';
import Skeleton, { Box } from 'react-skeletons';

const SkeletonMessage = () => (
  <div className='flex-rows' style={{ margin: '0 4px', alignItems: 'center' }}>
    <Box width={36} height={36} />
    <div style={{ marginLeft: 16, width: '100%', height: '100%' }}>
      <Skeleton count={2} />
    </div>
  </div>
);

export default () => (
  <div style={{ padding: 20 }}>
    <SkeletonMessage />
    <SkeletonMessage />
    <SkeletonMessage />
    <SkeletonMessage />
    <SkeletonMessage />
  </div>
);
